import { render, staticRenderFns } from "./Tracker.vue?vue&type=template&id=38fafaa6&"
import script from "./Tracker.vue?vue&type=script&lang=js&"
export * from "./Tracker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports